import React from 'react';
import { Alert } from '../../components/ui-kit';
import * as Sentry from '@sentry/browser';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      scope.setExtra('origin', 'ErrorBoundary');
      for (const key of Object.keys(errorInfo)) {
        scope.setExtra(key, errorInfo[key]);
      }
      Sentry.captureException(error);
    });
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <Alert variant="danger">
          <h3>Something went wrong</h3>
          <p>We have been notified about this issue and will investigate as soon as possible</p>
          <p>
            <details style={{ whiteSpace: 'pre-wrap' }}>
              {this.state.error && this.state.error.toString()}
              <br />
            </details>
          </p>
        </Alert>
      );
    }

    // Render children if there's no error
    return this.props.children;
  }
}

export default ErrorBoundary;
